import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/apiClient';

export interface AuditEntry {
  user_id?: string;
  action: string;
  entity_type: string;
  entity_id: string;
  before?: Record<string, unknown>;
  after?: Record<string, unknown>;
  ip?: string;
  user_agent?: string;
  is_platform_action?: boolean;
  created_at: number;
}

export interface AuditQuery {
  user_id?: string;
  entity_id?: string;
  from?: number;
  to?: number;
  limit?: number;
}

/** 操作日志查询（需 user_id 或 entity_id 之一）。enabled 控制是否真正发起。 */
export function useAudits(tid: string | undefined, q: AuditQuery, enabled: boolean) {
  return useQuery({
    queryKey: ['audits', tid, q],
    queryFn: () =>
      api
        .get<{ audits: AuditEntry[] }>(`/tenants/${tid}/audits`, {
          query: {
            ...(q.user_id ? { user_id: q.user_id } : {}),
            ...(q.entity_id ? { entity_id: q.entity_id } : {}),
            ...(q.from ? { from: q.from } : {}),
            ...(q.to ? { to: q.to } : {}),
            ...(q.limit ? { limit: q.limit } : {}),
          },
        })
        .then((r) => r.audits),
    enabled: enabled && !!tid, // 无 user_id/entity_id 时 = 整个产品时间线
  });
}

/** action → 中文标签 */
export const ACTION_LABEL: Record<string, string> = {
  'bom.create': '上传 BOM',
  'bom.replace': '覆盖 BOM',
  'bom.delete': '删除 BOM',
  'ecn.create': '上传 ECN',
  'ecn.delete': '删除 ECN',
  'member.add': '添加成员',
  'member.update': '修改成员',
  'member.remove': '移除成员',
  'contact.create': '添加联系人',
  'contact.update': '修改联系人',
  'contact.delete': '删除联系人',
  'contact.import_group': '导入联系人分组',
  'contactgroup.create': '创建联系人分组',
  'contactgroup.update': '修改联系人分组',
  'contactgroup.delete': '删除联系人分组',
  'groupcontact.create': '分组内添加联系人',
  'groupcontact.update': '分组内修改联系人',
  'groupcontact.delete': '分组内删除联系人',
  'emailconfig.save': '保存发件配置',
  'emailconfig.delete': '清除发件配置',
  'bom.notify': '发送 BOM 邮件',
  'ecn.notify': '发送 ECN 邮件',
  'user.change_password': '修改密码',
  'tenant.create': '创建产品',
  'tenant.update': '修改产品',
  'tenant.delete': '删除产品',
  'user.create': '创建用户',
  'user.disable': '停用用户',
  'user.delete': '删除用户',
  'user.reset_password': '重置密码',
};
